/** Registro de uma sessão do cronômetro de tarefas */
export interface TimeEntry {
  started_at: string;
  ended_at: string;
  seconds?: number;
  /** Registros antigos guardavam só minutos arredondados */
  minutes?: number;
}

/**
 * Tempo total trabalhado na tarefa, em segundos.
 * Usa a soma exata das sessões do cronômetro; sem sessões, cai para as horas reais informadas.
 */
export function getTrackedSeconds(task: { time_entries?: unknown; actual_hours?: number | null }): number {
  const entries = Array.isArray(task.time_entries) ? (task.time_entries as TimeEntry[]) : [];
  if (entries.length > 0) {
    return entries.reduce((total, entry) => {
      if (typeof entry.seconds === 'number') return total + entry.seconds;
      if (entry.started_at && entry.ended_at) {
        const exact = Math.round((new Date(entry.ended_at).getTime() - new Date(entry.started_at).getTime()) / 1000);
        if (exact >= 0) return total + exact;
      }
      return total + (Number(entry.minutes) || 0) * 60;
    }, 0);
  }
  return Math.round((Number(task.actual_hours) || 0) * 3600);
}

/** Ex.: 12 s · 4 min 12 s · 1h 04min 12s */
export function formatDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h) return `${h}h ${String(m).padStart(2, '0')}min ${String(s).padStart(2, '0')}s`;
  if (m) return `${m} min ${s} s`;
  return `${s} s`;
}
